import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useRef, useEffect, } from 'react';
import './code-otp-input.scss';
import { useMediaQuery } from '@mui/material';
const CODE_LENGTH = 6;
const CodeOTPInput = ({ hasError, hasExpired, onChange, shouldClearCode, onShouldClearCode, }) => {
    const [code, setCode] = useState(Array(CODE_LENGTH).fill(''));
    const [completed, setCompleted] = useState(false);
    const inputRefs = useRef([]);
    const hiddenInputRef = useRef(null);
    const isMobile = useMediaQuery('(max-width: 600px)');
    useEffect(() => {
        if (shouldClearCode) {
            const empty = Array(CODE_LENGTH).fill('');
            setCode(empty);
            setCompleted(false);
            onShouldClearCode(false);
            onChange(empty);
            inputRefs.current[0]?.focus();
        }
    }, [shouldClearCode]);
    useEffect(() => {
        if (!completed) {
            inputRefs.current[0]?.focus();
        }
    }, []);
    const fillCode = (value) => {
        const digits = value.replace(/\D/g, '').slice(0, CODE_LENGTH);
        if (!digits)
            return;
        const newCode = Array(CODE_LENGTH).fill('');
        digits.split('').forEach((d, i) => {
            newCode[i] = d;
        });
        setCode(newCode);
        onChange(newCode);
        const isCompleted = newCode.every((d) => d !== '');
        setCompleted(isCompleted);
        const focusIndex = Math.min(digits.length - 1, CODE_LENGTH - 1);
        inputRefs.current[focusIndex]?.focus();
        if (hiddenInputRef.current) {
            hiddenInputRef.current.value = '';
        }
    };
    const handlePaste = (event) => {
        event.preventDefault();
        fillCode(event.clipboardData.getData('text'));
    };
    const handleChange = (index, event) => {
        const inputEvent = event.nativeEvent;
        const value = inputEvent.data || '';
        if (/^\d{2,6}$/.test(value)) {
            event.preventDefault();
            fillCode(value);
            return;
        }
        else if (!/^\d?$/.test(value))
            return;
        const newCode = [...code];
        newCode[index] = value;
        setCode(newCode);
        onChange(newCode);
        const isCompleted = newCode.every((d) => d !== '');
        setCompleted(isCompleted);
        if (value && index < CODE_LENGTH - 1) {
            inputRefs.current[index + 1]?.focus();
        }
    };
    const handleBackspace = (index, event) => {
        if (event.key === 'Backspace' && !code[index] && index > 0) {
            event.preventDefault();
            inputRefs.current[index - 1]?.focus();
        }
    };
    return (_jsxs(_Fragment, { children: [_jsx("input", { ref: hiddenInputRef, type: "text", inputMode: "numeric", autoComplete: "one-time-code", style: {
                    position: 'absolute',
                    opacity: 0,
                    pointerEvents: 'none',
                    height: 0,
                    width: 0,
                }, onChange: (e) => fillCode(e.target.value) }), _jsx("div", { className: "code-otp-input", children: code.map((digit, index) => (_jsx("input", { ref: (el) => (inputRefs.current[index] = el), className: `code-otp-input_input ${hasError ? 'code-otp-input_input-error' : ''}`, type: "tel", inputMode: "numeric", maxLength: isMobile ? 6 : 1, value: digit, onInput: (e) => handleChange(index, e), onKeyDown: (e) => handleBackspace(index, e), onPaste: handlePaste }, index))) }), hasError && (_jsx("div", { className: "code-otp-input_error-label", children: "El c\u00F3digo ingresado no es v\u00E1lido" })), hasExpired && (_jsx("div", { className: "code-otp-input_error-label", children: "El c\u00F3digo ha expirado. Por favor, solicita un nuevo c\u00F3digo." }))] }));
};
export default CodeOTPInput;
